export function removeEmptyFields(obj) {
	for (const key in obj) {
		if (
			obj[key] === "" ||
			obj[key] === null ||
			obj[key] === undefined ||
			obj[key] === "-1" ||
			obj[key] === -1
		) {
			delete obj[key];
		}
	}
}
